import { put, call, takeLatest } from 'redux-saga/effects'

import { getLedgerRecords as getLedgerRecordsApi } from 'Service/Api'

import * as RecentExpenseTypes from 'Redux/Types/RecentExpenseTypes'
import * as RecentExpenseActions from 'Redux/Actions/RecentExpenseActions'

function* getRecentExpenseRecords({ payload }) {
  try {
    const { data } = yield call(getLedgerRecordsApi, payload)
    yield put(RecentExpenseActions.getRecentExpensesSucceeded(data))
  } catch (errors) {
    yield put(RecentExpenseActions.getRecentExpensesFailed(errors))
  }
}

export default function* RecentExpenseSaga() {
  yield takeLatest(RecentExpenseTypes.GET_RECENT_EXPENSE_RECORDS, getRecentExpenseRecords)
}
